const texts = {
  USER_PLACEHOLDER: "Email",
  NAME_PLACEHOLDER: "Nombre completo",
  EMAIL_PLACEHOLDER: "Email",
  PASSWORD_PLACEHOLDER: "Contraseña",
  ENTER: "Ingresar",
  ACCEPT: "Aceptar",
  CANCEL: "Cancelar",
  DELETE: "Eliminar",
  CREATE_ACCOUNT: "Crear cuenta",
  FORGOT_PASSWORD: "Olvidé mi contraseña",
  API_ERROR:
    "Ocurrió un error inesperado, por favor inéntalo denuevo más tarde.",
  ACTIVE_CARDS: "Cartas activas",
  SOLD_CARDS: "Cartas vendidas",
  SALES_HINT:
    "Cada venta muestra el total, la comisión de la tienda y lo que te corresponde.",
  NO_SALES: "Todavía no se vendió ninguna de tus cartas.",
  SALES_SEARCH: "Buscar por nombre de carta",
  SALES_NONE_MATCH: "Ninguna carta coincide con la búsqueda.",
  SALE_DATE: "Fecha",
  SALE_TOTAL: "Total",
  SALE_COMMISSION: "Comisión",
  SALE_YOURS: "Te corresponde",
  SALE_STATUS: "Estado",
  SALE_PAID: "Pagada",
  SALE_PENDING: "Pendiente",
  SALE_PARTIAL: "Parcial",
  SALES_PENDING_TOTAL: "Pendiente de pago:",
  DEACTIVATE: "Desactivar",
  ACTIVATE: "Activar",
  SOLD_ON: "Vendida",
  ADD_CARD: "Añadir carta",
  CHANGE_VERSION: "Cambiar versión",
  CHOOSE_VERSION: "Elegir",
  CURRENT_VERSION: "Actual",
  VERSION_CHANGED: "Versión actualizada.",
  SHIFT_BACK: "Correr desde acá un lugar atrás",
  POCKET_VISIBLE: "Visible",
  POCKET_ORDER_HINT: "La primera carta de la lista es la que se ve en el bolsillo.",
  STACK_UP: "Subir en la pila",
  STACK_DOWN: "Bajar en la pila",
  SHIFT_AHEAD: "Correr desde acá un lugar adelante",
  IMPORT_COLLECTION: "Importar colección",
  IMPORTING_COLLECTION: "Importando el archivo…",
  IMPORT_DONE_CARDS: " carta(s) importadas",
  IMPORT_SKIPPED: " bolsillo(s) vacío(s)",
  IMPORT_ERRORS: " fila(s) con error",
  CARD_NAME: "Escribe el nombre de la carta",
  SEARCH: "Buscar",
  SELECT_VERSION: "Selecciona la versión de tu carta.",
  CONDITION: "Estado",
  LANGUAGE: "Idioma",
  QUANTITY: "Cantidad",
  ADDING: "Añadiendo",
  ADD: "Añadir",
  HOME: "Home",
  MY_COLLECTION: "Colección",
  MY_SALES: "Ventas",
  MY_ACCOUNT: "Mi cuenta",
  BUY: "Comprar",
  LOGIN: "Ingresar",
  LOGOUT: "Salir",
  MENU: "Menú",
  CREATE_USERNAME: "Nombre de usuario",
  CREATE_NAME: "Nombre completo",
  CREATE_EMAIL: "Email",
  CREATE_PHONE: "Celular",
  CREATE_PASSWORD: "Contraseña",
  CONFIRM_DELETE_CARD_START: "¿Eliminar ",
  CONFIRM_DELETE_CARD_END: "?",
  AVAILABLE: "Disponibles: ",
  I_WANT_IT: "Lo quiero",
  STORE_SEARCH: "Busca en la tienda",
  SELL_CARDS: "Vender",
  PAYMENT: "Pagar",
  SELECT: "Seleccionar",
  CARDS_IN_SALE: "Cartas en la venta",
  FINISH_SALE: "Finalizar venta",
  CARDS_AVAILABLE_IN_STORE: "Cartas disponibles en la tienda",
  UPDATE_DETAILS: "Actualiza tus datos",
  UPDATED_DETAILS: "Tus datos han sido actualizados.",
  UPDATE_PASSWORD: "Actualiza tu contraseña",
  CURRENT_PASSWORD: "Contraseña actual",
  NEW_PASSWORD: "Nueva contraseña",
  CONFIRM_PASSWORD: "Repetir nueva contraseña",
  PASSWORD_MISMATCH: "Las contraseñas no coinciden.",
  PASSWORD_TOO_SHORT: "La contraseña debe tener al menos 8 caracteres.",
  // Account screen
  CREDIT_BALANCE: "Saldo de crédito",
  CREDIT_HINT: "Lo que la tienda te debe. Podés usarlo en tus compras.",
  SALE_MONEY_LABEL: "Dinero en la tienda",
  SALE_MONEY_HINT: "De la venta de tus cartas. Podés cobrarlo o usarlo en compras.",
  STORE_CREDIT_LABEL: "Store credit",
  STORE_CREDIT_HINT: "Cargado por la tienda. Solo para usar en compras.",
  VIEW_HISTORY: "Ver historial",
  MY_DETAILS: "Mis datos",
  EDIT: "Editar",
  PHONE_PLACEHOLDER: "Celular",
  NOT_SET: "—",
  CHANGE_PASSWORD: "Cambiar contraseña",
  PASSWORD_CHANGED: "Contraseña actualizada.",
  EMAIL_IS_LOGIN: "Tu email es tu usuario para ingresar.",
  // History sidebar (same shape as the admin's)
  HISTORY_TITLE: "Historial",
  HISTORY_EMPTY: "Todavía no tenés movimientos.",
  HIST_PURCHASE: "Compra",
  HIST_SALE: "Venta",
  HIST_CREDIT: "Crédito",
  HIST_PAYOUT: "Pago",
  HIST_CASH: "efectivo",
  HIST_CREDIT_PART: "crédito",
  HIST_MORE: "más",
  PAYMENT_TITLE: "Registrar un pago",
  AMMOUNT_PLACEHOLDER: "Monto",
  SELECT_USER: "Usuario",
  PAYMENT_PROCESSED: "Pago registrado exitosamente",
  SELECT_SET: "Seleccione un set para ver sus cartas",
  CLEAR: "Limpiar",
  FILTERS: " Filtros",
  LOADING_PRICE: "Cargando precio",
  PRICE_NOT_FOUND: "Precio no encontrado",
  ORDERS: "Pedidos",
  WISHLIST: "Deseados",
  MY_ORDERS: "Mis pedidos",
  TO_PICK_UP: "Para retirar",
  PICKUP_EXPLAIN: "Estas cartas están apartadas a tu nombre en la tienda.",
  PREPARING_TITLE: "En preparación",
  PREPARING_EXPLAIN:
    "La tienda está armando estos pedidos. Te avisamos cuando puedas retirarlos.",
  PREPARING_NOTE: "La tienda está preparando tu pedido.",
  ORDER_STATUS_preparing: "Preparando",
  ORDER_HISTORY: "Historial",
  NOTIF_purchase: "Conseguimos una carta de tu lista de deseados",
  NOTIF_withdrawal: "Una carta tuya está lista para que la retires",
  NOTIF_order_ready: "Tu pedido está listo para retirar",
  NOTIF_NO_CHARGE: "sin cargo, es tuya",
  NOTIF_DISMISS: "Ok",
  NOTHING_TO_PICK_UP: "No tienes cartas apartadas.",
  LINE_FREE: "Sin cargo",
  PICKUP_NOTE_FREE: "Retiras en la tienda, sin cargo.",
  MY_WISHLIST: "Mis deseados",
  IMPORT_MOXFIELD: "Importar de Moxfield",
  MOXFIELD_URL: "Link del mazo",
  MOXFIELD_HINT:
    "Pegá el link de un mazo público de Moxfield. Sus cartas se agregan a tus deseados sin preferencias; después podés ajustarlas.",
  MOXFIELD_IMPORT: "Importar",
  MOX_ADDED: " carta(s) agregadas",
  MOX_EXISTING: " ya estaban en tu lista",
  MOX_NOTFOUND: " no se encontraron",
  RESERVE: "Reservar",
  RESERVED_OK: "Reservado. Pasa por la tienda a retirarlo.",
  CANCEL_ORDER: "Cancelar",
  CONFIRM_CANCEL_ORDER: "¿Cancelar este pedido?",
  EDIT_ORDER: "Editar",
  EDIT_ORDER_TITLE: "Editar pedido",
  EDIT_ORDER_HINT:
    "Quitá las cartas que ya no quieras. Si quitás todas, el pedido se cancela.",
  REMOVE_FROM_ORDER: "Quitar",
  CANCEL_ORDER_FULL: "Cancelar todo el pedido",
  ORDER_STATUS_pending: "Reservado",
  ORDER_STATUS_completed: "Entregado",
  ORDER_STATUS_cancelled: "Cancelado",
  ORDER_STATUS_expired: "Vencido",
  ORDER_EXPIRES: "Vence el",
  ORDER_TOTAL: "Total",
  NO_ORDERS: "Todavía no hiciste ningún pedido.",
  NO_WISHLIST: "Tu lista de deseados está vacía.",
  ADD_WISHLIST: "Agregar a deseados",
  WISHLIST_PLACEHOLDER: "Buscá una carta",
  AVAILABLE_NOW: "Disponibles",
  RESERVED_BY_OTHERS: "reservadas",
  PICKUP_NOTE: "Pagas y retiras en la tienda.",
  WISHLIST_ANY: "Cualquiera",
  WISHLIST_VERSIONS: "Versiones",
  WISHLIST_LANGUAGES: "Idiomas",
  WISHLIST_GRADES: "Estados",
  WISHLIST_FINISHES: "Terminación",
  VARIANT_nonfoil: "Normal",
  VARIANT_foil: "Foil",
  VARIANT_etched: "Etched",
  ONLY_FINISH: "Solo existe en",
  WISHLIST_EDIT: "Preferencias",
  WISHLIST_QUANTITY: "Cantidad",
  WISHLIST_AUTOBUY: "Comprar automáticamente",
  WISHLIST_WANT: "Querés",
  CLOSE: "Cerrar",
  WISHLIST_SAVE: "Guardar preferencias",
  WISHLIST_SAVED: "Preferencias guardadas.",
  WISHLIST_ANY_HINT:
    "Si no marcas nada en una categoría, aceptas cualquiera.",
  WISHLIST_LOADING_VERSIONS: "Cargando versiones...",
  WISHLIST_FILTER_SET: "Filtrar por código de set",
  AUTOCOMPLETE_HINT: "Escribí al menos dos letras.",
  AUTOCOMPLETE_NONE: "No hay cartas con ese nombre.",

  // Storefront search. The options offered are built from what the shop
  // actually holds, so these label real choices rather than the whole game.
  SEARCH_NAME: "Nombre de la carta",
  SEARCH_SET: "Edición",
  SEARCH_TYPE: "Tipo",
  SEARCH_COLORS: "Colores",
  SEARCH_ANY: "Cualquiera",
  SEARCH_RESULTS: "Resultados",
  SEARCH_TRUNCATED:
    "Hay más cartas de las que podemos mostrar; afiná la búsqueda.",
  NO_RESULTS: "No hay cartas en la tienda que coincidan con esa búsqueda.",
  STORE_PROMPT:
    "Buscá por nombre, edición, tipo o color para ver qué tenemos en la tienda.",
  LOGIN_TO_ORDER: "Ingresa para pedir",
  ADD_TO_WISHLIST: "Agregar a deseados",
  IN_WISHLIST: "Ya está en tus deseados",
  ADDED_TO_WISHLIST: "agregada a tus deseados",
  REMOVED_FROM_WISHLIST: "eliminada de tus deseados",
  CURRENCY: "U$S",
  COLOR_W: "Blanco",
  COLOR_U: "Azul",
  COLOR_B: "Negro",
  COLOR_R: "Rojo",
  COLOR_G: "Verde",
  COLOR_C: "Incoloro",

  // Binders and boxes the customer owns. The lifecycle mirrors
  // services/storageState.js in the API.
  MY_STORAGE: "Contenedores",
  MY_STORAGE_TITLE: "Mis carpetas y cajas",
  CONTAINER_EMPTY: "Este contenedor está vacío.",
  STANDBY_TITLE: "En espera",
  STANDBY_HINT:
    "Arrastrá cartas acá para sacarlas de un bolsillo, y de acá a otro bolsillo.",
  STANDBY_EMPTY: "Sin cartas en espera.",
  POCKET_STACK: "Cartas en este bolsillo",
  POCKET_EXPAND_HINT:
    "Este bolsillo tiene varias cartas. Mandá una a la zona de espera para moverla.",
  TO_STANDBY: "A espera",
  DUPLICATE_COPY: "Duplicar (tengo otra igual)",
  DUPLICATE_FAILED: "No se pudo duplicar la carta:",
  ZOOM_CARD: "Ampliar carta",
  REMOVE_FAILED: "No se pudo sacar la carta:",
  DRAG_TO_REORDER: "Arrastrá para reordenar",
  UNSORTED_HINT:
    "Una caja sin ordenar no guarda posiciones; se lista alfabéticamente.",
  STANDBY_DISCARD_TITLE: "Quedan cartas en espera",
  STANDBY_DISCARD_1: "Si salís ahora se van a eliminar ",
  STANDBY_DISCARD_2:
    " carta(s) que dejaste en espera. Una carta no puede quedar sin contenedor.",
  STANDBY_KEEP_EDITING: "Seguir editando",
  STANDBY_DISCARD_CONFIRM: "Eliminar y salir",
  ADDED_TO_CONTAINER: "añadida(s) a",
  ADD_PAGE: "Añadir página",
  STORAGE_TYPE: "Tipo",
  STORE: "Tienda",
  BUY_NOW: "Comprar",
  RESERVED_FOR_YOU: "Apartada para vos",
  ITS_YOURS: "Es tuya",
  CONTAINER_MINE: "Tuyo",
  REQUEST_MINE_BACK: "Pedir que me lo devuelvan",
  MINE_NOTE: "Esta carta es tuya.",
  BROWSE_UNITS: "Mirar carpetas y cajas",
  BROWSE_SUBTITLE: "Elegí un contenedor para ver sus cartas.",
  BROWSE_EMPTY:
    "La tienda no tiene carpetas ni cajas para mirar en este momento.",
  NOT_FILED_YET: "Sin archivar todavía",
  SOLD_OUT: "Sin stock",
  CART: "Carrito",
  ADD_TO_CART: "Agregar al carrito",
  IN_YOUR_CART: "En tu carrito",
  CART_EMPTY_PAGE:
    "Tu carrito está vacío. Buscá cartas en la tienda o mirá las carpetas y cajas.",
  CART_HINT:
    "Al confirmar el pedido, la tienda va a apartar las cartas para que pases a retirarlas.",
  CART_CONFIRM: "Confirmar pedido",
  CART_TOTAL: "Total",
  CART_CREDIT_AVAILABLE: "Crédito disponible",
  CART_REMOVE_ITEM: "Quitar",
  CART_OUT_OF_STOCK: "Ya no hay stock suficiente de esta carta.",
  CART_PARTIAL:
    "Algunas cartas ya no estaban disponibles y quedaron en el carrito.",
  GO_TO_STORE: "Ir a la tienda",
  REQUEST_WITHDRAWAL: "Pedir para retirar",
  FILTER_BY_SET: "Filtrar por edición (nombre o código)",
  FILTER_BY_SET_SHORT: "Edición",
  OF: "de",
  VERSIONS: "versiones",
  NO_VERSIONS: "Ninguna versión coincide con el filtro.",
  LOADING_VERSIONS: "Cargando versiones...",
  PREV_PAGES: "Páginas anteriores",
  NEXT_PAGES: "Páginas siguientes",
  GO_TO_PAGE: "Ir a página",
  BACK_TO_STORAGE: "Volver",
  REMOVE_FROM_CONTAINER: "Sacar",
  PAGE: "Página",
  POCKET: "bolsillo",
  NO_STORAGE: "Todavía no tenés ninguna carpeta ni caja.",
  STORAGE_SEARCH: "Buscar por nombre",
  STORAGE_NO_MATCHES: "Ningún contenedor coincide con la búsqueda.",
  PER_PAGE: "Por página:",
  NEW_STORAGE: "Nuevo contenedor",
  STORAGE_NAME: "Nombre",
  BINDER: "Carpeta",
  SORTED_BOX: "Caja ordenada",
  UNSORTED_BOX: "Caja sin ordenar",
  // Only the shop makes these, but its cards are on the shelf like any
  // other's, so the storefront has to be able to name one.
  EDITION_BOX: "Caja de edición",
  CREATE: "Crear",
  CARDS: "cartas",
  RENAME: "Renombrar",
  SAVE: "Guardar",
  STATE_FOR_SALE: "En la tienda, en venta",
  STATE_RETIRED: "Pediste que te lo devuelvan",
  STATE_RELEASED: "Lo tenés vos",
  STATE_RETURNING: "Lo estás llevando a la tienda",
  DO_RETIRE: "Pedir que me lo devuelvan",
  DO_RETURN: "Llevarlo a la tienda",
  RETIRE_EXPLAIN:
    "Sus cartas dejan de estar a la venta en cuanto lo pedís, aunque todavía esté en la tienda.",
  RETIRED_COMMITTED_1: "Quedan ",
  RETIRED_COMMITTED_2:
    " carta(s) apartadas para un pedido; esas ya están comprometidas y se quedan en la tienda.",
  CONFIRM_DELETE_STORAGE: "¿Eliminar este contenedor?",
  CONFIRM_DELETE_STORAGE_CARDS_1: "Este contenedor tiene ",
  CONFIRM_DELETE_STORAGE_CARDS_2:
    " carta(s) adentro. Al eliminarlo también se eliminan esas cartas. ¿Continuar?",
  STORAGE_LOCKED:
    "Sólo podés reordenarlo mientras lo tengas vos.",
};

export default texts;
